import { FilterField } from "~/features/filter";
import { language } from "~/libs/getData";
import { filterByArr } from "~/pages/Staff/assets/StaffFilter/lib";
import { useFilterItemOptions } from "~/pages/StaffBonus/Filter/optionsHooks";

type Translate = (key: string) => string;

/** Все ключи URL, которыми владеет фильтр. */
export const DEALER_METRIC_FILTER_KEYS = ["filterBy", "filterItems", "period"];

/**
 * Поля фильтра страницы «Справочник показателей для расчета нормативной
 * численности ДЦ». Имена полей совпадают с URL-параметрами — значения
 * фильтра хранятся в query-строке, а запрос собирается из них в DealerMetric.
 */
export const dealerMetricFilterFields = (t: Translate): FilterField[] => {
  const isEn = language === "en";

  return [
    {
      name: "filterBy",
      type: "select",
      label: t("staff.filter_by"),
      // При смене измерения значения прошлого измерения не имеют смысла —
      // сбрасываем зависимое поле (его опции переключатся через useWatch).
      resetFieldsOnChange: ["filterItems"],
      options: filterByArr.map((el) => ({
        value: el.value,
        label: isEn ? el.labelEn : el.label,
      })),
    },
    {
      name: "filterItems",
      type: "select",
      multiple: true,
      label: t("dealerMetrics.values"),
      // Опции зависят от filterBy: дилеры — с пагинацией/поиском,
      // локации — списками из справочника (useWatch внутри хука).
      optionsHook: useFilterItemOptions,
    },
    {
      name: "period",
      type: "datePicker",
      label: t("dealerMetrics.onTheDate"),
    },
  ];
};
